/** @jsx jsx */

import { ComponentProps, PropsWithChildren } from 'react';

import { Margin, Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import { DEV_BREAK_POINTS } from 'app/developer-v3/constants';

const Styles = {
  content: css`
    padding: 15px;
    @media screen and (max-width: ${DEV_BREAK_POINTS.default}) {
      flex-direction: column;
    }
  `,
};

const HeaderCTA = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Text tag="h3" type="Body4">
      {children}
    </Text>
  );
};

const BodyCTA = ({
  children,
  margin,
}: PropsWithChildren<{ margin: ComponentProps<typeof Margin>['margin'] }>) => {
  return <Margin margin={margin}>{children}</Margin>;
};

const CTA = (props: PropsWithChildren<{}>) => {
  const { children } = props;
  return (
    <Margin margin="15px 0px 0px">
      <Surface borderColor="GrayWarm4">
        <div css={Styles.content}>{children}</div>
      </Surface>
    </Margin>
  );
};

CTA.Header = HeaderCTA;
CTA.Body = BodyCTA;

export default CTA;
